import { Table } from "dyl-components";
import React from "react";
import { Header, Segment } from "semantic-ui-react";
import DataRow from "./DataRow";
import DataHeader from "./DataHeader";

const DataTable = ({
    fields,
    control,
    getValues,
    update,
    setEditingRows,
    editingRows,
    remove,
    onDeleteConfirm,
    watch,
}) => {
    const setEditMode = (index, value) => {
        setEditingRows((prev) => ({
            ...prev,
            [index]: value,
        }));
    };

    return (
        <Table>
            <DataHeader />

            <Table.Body>
                {fields?.length > 0 ? (
                    fields?.map?.((item, index) => (
                        <DataRow
                            key={item?.id}
                            control={control}
                            getValues={getValues}
                            index={index}
                            isEditing={editingRows?.[index]}
                            item={item}
                            update={update}
                            setEditMode={setEditMode}
                            remove={remove}
                            onDeleteConfirm={onDeleteConfirm}
                            watch={watch}
                        />
                    ))
                ) : (
                    <Table.Row>
                        <Table.Cell colSpan={3}>
                            <Segment basic textAlign="center">
                                <Header as="h3">No URLs Added</Header>
                            </Segment>
                        </Table.Cell>
                    </Table.Row>
                )}
            </Table.Body>
        </Table>
    );
};

export default DataTable;
